<template>
  <div class="app-container">
    <div class="form-container">
      <el-form :model="data" :rules="rules" ref="form" label-width="200px" v-loading="isLoading">
        <div :style="isMB ? '' : 'padding:20px 20px 0 0;'">
          <el-row>
            <el-col :span="10">
              <el-form-item label="温度1下限" prop="T1lower">
                <el-input type="number" v-model="data.T1lower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="温度1上限" prop="T1upper">
                <el-input type="number" v-model="data.T1upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="温度2下限" prop="T2lower">
                <el-input type="number" v-model="data.T2lower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="温度2上限" prop="T2upper">
                <el-input type="number" v-model="data.T2upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="温度3下限" prop="T3lower">
                <el-input type="number" v-model="data.T3lower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="温度3上限" prop="T3upper">
                <el-input type="number" v-model="data.T3upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="温度4下限" prop="T4lower">
                <el-input type="number" v-model="data.T4lower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="温度4上限" prop="T4upper">
                <el-input type="number" v-model="data.T4upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="温度5下限" prop="T5lower">
                <el-input type="number" v-model="data.T5lower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="温度5上限" prop="T5upper">
                <el-input type="number" v-model="data.T5upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="温度6下限" prop="T6lower">
                <el-input type="number" v-model="data.T6lower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="温度6上限" prop="T6upper">
                <el-input type="number" v-model="data.T6upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="温度7下限" prop="T7lower">
                <el-input type="number" v-model="data.T7lower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="温度7上限" prop="T7upper">
                <el-input type="number" v-model="data.T7upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="温度8下限" prop="T8lower">
                <el-input type="number" v-model="data.T8lower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="温度8上限" prop="T8upper">
                <el-input type="number" v-model="data.T8upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="温度9下限" prop="T9lower">
                <el-input type="number" v-model="data.T9lower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="温度9上限" prop="T9upper">
                <el-input type="number" v-model="data.T9upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="温度10下限" prop="T10lower">
                <el-input type="number" v-model="data.T10lower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="温度10上限" prop="T10upper">
                <el-input type="number" v-model="data.T10upper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="10">
              <el-form-item label="油温下限" prop="Otlower">
                <el-input type="number" v-model="data.Otlower"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="油温上限" prop="Otupper">
                <el-input type="number" v-model="data.Otupper"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div class="bottom-pnl">
      <el-button v-if="$permission.canWrite()" type="primary" @click="onSubmit" size="small">保 存</el-button>
    </div>
</div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import singlePicUpload from '@/components/common/photo/singleUpload'

export default {
  name: 'datathreshold',
  mixins: [editDialogMixin],
  components: {
    singlePicUpload
  },

  data() {
    return {
      data: {
        RecordId: 0,
        T1lower: null,
        T1upper: null,
        T2lower: null,
        T2upper: null,
        T3lower: null,
        T3upper: null,
        T4lower: null,
        T4upper: null,
        T5lower: null,
        T5upper: null,
        T6lower: null,
        T6upper: null,
        T7lower: null,
        T7upper: null,
        T8lower: null,
        T8upper: null,
        T9lower: null,
        T91upper: null,
        T10lower: null,
        T10upper: null,
        Otlower: null,
        Otupper: null
      },
      dialogVisible: false,
      isLoading: false,
      isMB: this.$store.state.isMB,
      headers: { Authorization: '' },
      api: require('@/api/ba/datathreshold').default,
      canEdit: false,
      rules: {},
      uploadUrl: '/api/Common/UploadPicture'
    }
  },
  mounted() {
    this.canEdit = this.$permission.canWrite()
    this.api.info(1).then(res => {
      if (res.Code == 0) {
        this.data = res.Data
      } else {
        this.$message.error(res.Msg)
      }
    })
  },
  methods: {
    checkInt(name) {
      if (!(this.data[name] >= 0)) {
        this.data[name] = 0
      } else if (this.data[name] % 1 != 0) {
        this.data[name] = Math.floor(this.data[name])
      }
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isLoading = true
          this.api.save(this.data).then(res => {
            this.isLoading = false
            if (res.Code == 0) {
              this.$message.success(res.Msg);
            } else {
              this.$message.error(res.Msg)
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="scss">
  .form-container{
    padding: 10px;
  }

  .bottom-pnl {
    padding: 10px;
    width: 100%;
    text-align: center;
  }
</style>